import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {usePermissions} from '../hooks/usePermissions';
import {getWebsiteEditorContext} from '../services/organizationWorkspaceReader';
import {websiteEditorFor} from '../config/websiteVerticalContract';

// Mount no generic editor (and therefore no autosave) until its owner is known.
export default function WebsiteEditorBoundary({children}) {
  const {orgSlug} = useParams();
  const {uid} = usePermissions(orgSlug);
  const key = `${orgSlug}:${uid || ''}`;
  const [state, setState] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setState(null);
    const timer = setTimeout(() => {if(active){active=false;setState({key,error:'Checking the website editor timed out. Please retry.'});}},20000);
    getWebsiteEditorContext(orgSlug).then(org => {if(active)setState({key,...websiteEditorFor(org,orgSlug)});}).catch(() => {if(active)setState({key,error:'We could not load the organization’s website settings. Please retry.'});}).finally(()=>clearTimeout(timer));
    return ()=>{active=false;clearTimeout(timer);};
  },[key,orgSlug,attempt]);
  const current = state?.key === key ? state : null;
  if(current?.kind === 'organization') return children;
  return <section className="m-4 rounded-2xl border bg-white p-6"><h1>Manage website</h1>{!current ? <p role="status">Checking your website editor…</p> : current.error || current.kind === 'unavailable' ? <><p role="alert">{current.error || current.reason}</p><button onClick={()=>setAttempt(n=>n+1)}>Retry</button></> : <><p>This website is managed in {current.label}. Your saved drafts have not been changed.</p><Link to={current.path}>Open {current.label}</Link></>}<p><Link to={`/platform/o/${orgSlug}/dashboard`}>Back to dashboard</Link></p></section>;
}
